export default __webpack_public_path__ + "static/media/svenKlein.7b5ea097.jpg";